<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">项目编号：</span>
        <el-input v-model="proNo" :size="size" clearable placeholder="请输入项目编号"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="proId" :size="size" clearable placeholder="请选择项目" @change="getAllSegmentData">
          <el-option
            v-for="item in projectData"
            :key="item.proId"
            :label="item.proName"
            :value="item.proId">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">项目标段：</span>
        <el-select v-model="segmentId" :size="size" clearable placeholder="请选择标段">
          <el-option
            v-for="item in segmentData"
            :key="item.segmentId"
            :label="item.segmentName"
            :value="item.segmentId">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
      <el-button icon="el-icon-search" @click="searchProjectInfoList(true)">查询</el-button>
      <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      <el-button icon="el-icon-download" @click="exportExcel()">导出Excel</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="projectInfoList"
        height="100%">
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="proNo" label="项目编号" align="center"></el-table-column>
        <el-table-column prop="proName" label="项目名称" align="center"></el-table-column>
        <el-table-column prop="segmentName" label="项目标段" align="center"></el-table-column>
        <el-table-column prop="proAdminName" label="项目经理" align="center"></el-table-column>
        <el-table-column prop="proAdminPhone" label="联系电话" align="center"></el-table-column>
        <el-table-column prop="planStartTime" label="计划开始时间" align="center"></el-table-column>
        <el-table-column prop="planEndTime" label="计划结束时间" align="center"></el-table-column>
        <el-table-column prop="startTime" label="实际开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="实际结束时间" align="center"></el-table-column>
        <el-table-column prop="proDesc" label="项目描述" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="上传项目文件" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini"  @click="propLookFile(row)">查看文件</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <!-- <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增项目信息 修改项目信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增项目信息' : '修改项目信息'"
      :visible.sync="asyncProjectInfo"
      width="35%">
      <el-form ref="form" :model="formProjectInfo" :rules="rulesProjectInfo" label-width="auto" class="rule_form">
        <el-form-item label="项目名称：" prop="proId">
          <el-select v-model="formProjectInfo.proId" :size="size" clearable placeholder="请选择项目" @change="getAllSegmentDatas">
            <el-option
              v-for="item in projectDatas"
              :key="item.proId"
              :label="item.proName"
              :value="item.proId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目编号：" prop="proNo">
          <el-input v-model="formProjectInfo.proNo" :size="size" clearable placeholder="请输入项目编号"></el-input>
        </el-form-item>
        <el-form-item label="项目标段：" prop="segmentId">
          <el-select v-model="formProjectInfo.segmentId" :size="size" clearable placeholder="请选择标段">
            <el-option
              v-for="item in segmentDatas"
              :key="item.segmentId"
              :label="item.segmentName"
              :value="item.segmentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目经理：" prop="proAdmin">
          <el-select v-model="formProjectInfo.proAdmin" :size="size" clearable placeholder="请选择项目经理" @change="changeUserPhone">
            <el-option
              v-for="item in staffData"
              :key="item.userId"
              :label="item.realName"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话：" prop="proAdminPhone">
          <el-input v-model="formProjectInfo.proAdminPhone" disabled :size="size" placeholder="请输入项目经理联系电话"></el-input>
        </el-form-item>
        <el-form-item label="计划开始时间：" prop="planStartTime">
          <el-date-picker 
            v-model="formProjectInfo.planStartTime" 
            type="date"
            :size="size"
            clearable
            value-format="yyyy-MM-dd"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="计划结束时间：" prop="planEndTime">
          <el-date-picker 
            v-model="formProjectInfo.planEndTime" 
            type="date"
            :size="size"
            clearable
            value-format="yyyy-MM-dd"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际开始时间：">
          <el-date-picker 
            v-model="formProjectInfo.startTime" 
            type="date"
            :size="size"
            clearable
            value-format="yyyy-MM-dd"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际结束时间：">
          <el-date-picker 
            v-model="formProjectInfo.endTime" 
            type="date"
            :size="size"
            clearable
            value-format="yyyy-MM-dd"
            placeholder="请选择实际结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目描述：" prop="proDesc">
        <el-input 
          type="textarea" 
          v-model="formProjectInfo.proDesc"
          :size="size"
          clearable
          placeholder="请输入项目描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传项目文件：" prop="proInfoFileList">
					<upload-file :file-list.sync="formProjectInfo.proInfoFileList">
						<template #info>
							<span>点击上传文件，支持xls、xlsx、ppt、doc、docx、pdf格式</span>
						</template>
					</upload-file>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncProjectInfo = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 查看文件 -->
    <look-file :file-list.sync="fileList" :async-file.sync="asyncFile"></look-file>
  </div>
</template>

<script>
import UploadFile from '../../components/uploadFile';
import LookFile from '../../components/LookFile';
import { buttonPinia } from '../../pinia';
import { changeSize, downLoadFile, throttle } from '../../plugins/public';
  export default {
    data() {
      var fileMustUpload = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请上传项目文件'));
        } else if (value.length < 0) {
          callback(new Error('请上传项目文件'));
        } else {
          this.$refs.form.clearValidate('proInfoFiles');
          callback();
        }
      };
      return {
        proId: '',
        projectData: [],
        projectDatas: [],
        proNo: '',
        segmentId: '',
        segmentData: [],
        segmentDatas: [],
        size: changeSize(),
        total: 0,
        pageNum: 1,
        pageSize: 10,
        loading: false,
        projectInfoList: [], // 列表信息
        asyncTitle: true, // true 新增信息 false 修改信息
        asyncProjectInfo: false, // 弹窗
        formProjectInfo: {
          proInfoFileList: []
        }, // 表单信息
        rulesProjectInfo: {
          proId: [{
            required: true,
            message: '请选择项目',
            trigger: ['change', 'blur']
          }],
          proNo: [{
            required: true,
            message: '请输入项目编号',
            trigger: 'blur'
          }],
          segmentId: [{
            required: true,
            message: '请选择标段',
            trigger: ['change', 'blur']
          }],
          proAdmin: [{
            required: true,
            message: '请选择项目经理',
            trigger: ['blur', 'change']
          }],
          proAdminPhone: [{
            required: true,
            message: '请输入项目经理联系电话',
            trigger: 'blur'
          }, {
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }],
          planStartTime: [{
            required: true,
            message: '请选择计划开始时间',
            trigger: ['change', 'blur']
          }],
          planEndTime: [{
            required: true,
            message: '请选择计划结束时间',
            trigger: ['change', 'blur']
          }],
          proDesc: [{
            required: true,
            message: '请输入项目描述',
            trigger: 'blur'
          }],
          proInfoFileList: [{
            required: true,
            message: '请上传项目文件'
          }, {
            validator: fileMustUpload,
            trigger: ['change']
          }],
        }, // 表单校验规则
        asyncFile: false, // 查看文件弹窗
        fileList: [], // 查看文件列表
        pdfUrl: '',
        staffData: [], // 人员信息
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.getAllProjectData();
      that.getAllStaffData();
      that.searchProjectInfoList(true);
    },
    methods: {
      // 获取全部项目信息
      async getAllProjectData() {
        const { data } = await this.$api.Engineer.searchProjects({
          pageNum: 1,
          pageSize: 1000000
        });
        this.projectData = data.list;
        this.projectDatas = data.list;
      },
      // 获取所有人员信息
      async getAllStaffData() {
        const { data } = await this.$api.Personnerl.GETSTAFFALLDATA();
        this.staffData = data;
      },
      // 获取项目下标段信息
      async getAllSegmentData(projectId) {
        this.segmentId = '';
        if(projectId) {
          const { data } = await this.$api.Engineer.searchSegment({
            proId: projectId,
            pageNum: 1,
            pageSize: 1000000
          });
          this.segmentData = data.list;
        } else {
          this.segmentData = [];
        }
      },
      // 获取项目下标段信息
      async getAllSegmentDatas(projectId) {
        this.segmentDatas = [];
        this.$set(this.formProjectInfo, 'segmentId', '');
        if(projectId) {
          const { data } = await this.$api.Engineer.searchSegment({
            proId: projectId,
            pageNum: 1,
            pageSize: 1000000
          });
          this.segmentDatas = data.list;
        }
      },
      // 查询列表信息
      searchProjectInfoList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.projectInfoList = [];
        this.$api.Project.searchProjectInfoList({
          proId: this.proId,
          proNo: this.proNo,
          segmentId: this.segmentId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.projectInfoList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncProjectInfo = true;
      },
      // 导出excel
      exportExcel() {
        this.$api.System.GETEXPORTTOKENDATA({
          proId: this.proId,
          proNo: this.proNo,
          segmentId: this.segmentId,
        }).then((res) => {
          if(res.success) {
            console.log(res);
            downLoadFile(res.data, '/pm/projectInfo/export');
          }
        })
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncProjectInfo = true;
        this.getAllSegmentData(row.proId);
        this.$set(this.formProjectInfo, 'proInfoId', row.proInfoId);
        this.$set(this.formProjectInfo, 'proId',  row.proId);
        this.$set(this.formProjectInfo, 'proNo', row.proNo);
        this.$set(this.formProjectInfo, 'segmentId', row.segmentId);
        this.$set(this.formProjectInfo, 'proAdmin', row.proAdmin);
        this.$set(this.formProjectInfo, 'proAdminPhone', row.proAdminPhone);
        this.$set(this.formProjectInfo, 'planStartTime', row.planStartTime);
        this.$set(this.formProjectInfo, 'planEndTime', row.planEndTime);
        this.$set(this.formProjectInfo, 'startTime', row.startTime);
        this.$set(this.formProjectInfo, 'endTime', row.endTime);
        this.$set(this.formProjectInfo, 'proDesc', row.proDesc);
        this.$api.Project.getProjectFileInfo({
          proInfoId: row.proInfoId
        }).then((res) => {
        this.$set(this.formProjectInfo, 'proInfoFileList', res.data.list.map((item, index) => {
            const type = item.proInfoFileName.split('.');
            return {
              id: index + 1,
              type: type[type.length - 1],
              name: item.proInfoFileName,
              url: item.proInfoFile
            }
          }))
        })
      },
      // 查看文件
      propLookFile(row) {
        this.fileList = [];
        this.$api.Project.getProjectFileInfo({
          proInfoId: row.proInfoId
        }).then((res) => {
          this.fileList = res.data.list.map((item, index) => {
            const type = item.proInfoFileName.split('.');
            return {
              id: index + 1,
              type: type[type.length - 1],
              name: item.proInfoFileName,
              url: item.proInfoFile
            }
          });
        })
        this.asyncFile = true;
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formProjectInfo);
            params.proInfoFileList = params.proInfoFileList.map(item => {
              return {
                proInfoFile: item.url
              }
            });
            this.$api.Project.insertProjectInfo(params).then((res) => {
              if(res.success) {
                this.asyncProjectInfo = false;
                this.searchProjectInfoList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formProjectInfo);
            params.proInfoFileList = params.proInfoFileList.map(item => {
              return {
                proInfoFile: item.url
              }
            });
            this.$api.Project.insertProjectInfo(params).then((res) => {
              if(res.success) {
                this.asyncProjectInfo = false;
                this.searchProjectInfoList(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 获取项目经理手机号
      changeUserPhone(data) {
        this.$set(this.formProjectInfo, 'proAdminPhone', '');
        if(data) {
          const object = this.staffData.find(item => item.userId === data);
          this.$set(this.formProjectInfo, 'proAdminPhone', object.phone);
        }
      },
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchProjectInfoList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchProjectInfoList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    },
    components: {
      UploadFile,
      LookFile
    },
    watch: {
      asyncProjectInfo(bol) {
        if(bol) {
          this.getAllProjectData();
        } else {
          this.projectDatas = [];
          this.segmentDatas = [];
          this.formProjectInfo = {
            proInfoFileList: []
          };
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>